import { Size } from '@/components/Menu'
import { Modifier } from '@/components/Menu/Modifiers'
import { BasicOfferInfo, VenueTable } from '@/components/home/types'
import { NEXT_ROUND_ORDER_KEY } from '@/constants'
import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { v4 as uuidv4 } from 'uuid'
export interface Item {
  name: string
  note: string
  quantity: number
  size: Size
  price: number
  item_id: number
  size_id: number
  offers: BasicOfferInfo[]
  modifiers: Modifier[]
  id: string
  single: boolean
  description?: string
  image_url?: string
  available_quantity?: number | null
}

export function isItem(entity: any): entity is Item {
  return (
    typeof entity === 'object' &&
    entity !== null &&
    'name' in entity &&
    'note' in entity &&
    'quantity' in entity &&
    'size' in entity &&
    'price' in entity &&
    'item_id' in entity &&
    'size_id' in entity &&
    'offers' in entity &&
    'modifiers' in entity &&
    'id' in entity &&
    'single' in entity
  )
}

export const orderAtom = atom<Item[]>([])
export const orderUuidAtom = atomWithStorage<string>('order_uuid', uuidv4().toUpperCase())

export const hasPlacedAnOrderOnTabAtom = atomWithStorage<boolean>('hasPlacedAnOrderOnTab', false)
//this is similar to hasPlacedAnOrderOnTabAtom, but we derive it from backend state
// we don't want to do that with hasPlacedAnOrderOnTabAtom because of possibility of refresh during order submit
export const runningTabIsEmptyAtom = atom<boolean>(true)

export const menuModalAtom = atom<boolean>(false)
export const tableModalAtom = atom<boolean>(false)

export const closeOrderModalAtom = atom(false)

export const venueTableAtom = atom<VenueTable | null>(null)

export const viewOrderAtom = atom(false)

export const orderConfirmationNoteAtom = atom<string | null>(null)

export const closeTabModalIsOpenAtom = atom<boolean>(false)

export const hasCardIncAuthErrorAtom = atom<boolean>(false)

export const slmSelectedModifiersAtom = atom<Modifier[]>([])

export const isPostOrderAdOpenAtom = atom<boolean>(false)

export const nextRoundOrderAtom = atomWithStorage<{ order: Item[]; venue_id: string }>(NEXT_ROUND_ORDER_KEY, {
  order: [],
  venue_id: '',
})
export const isNextRoundOpenAtom = atom<boolean>(false)

export const clickedOnNextRoundAtom = atom<boolean>(false)
